module.exports = __webpack_public_path__ + "static/img/nav12.9f057d3e.svg";